import { render, staticRenderFns } from "./joining-details.vue?vue&type=template&id=6b99ed87&"
import script from "./joining-details.vue?vue&type=script&lang=js&"
export * from "./joining-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports